import React, { useState } from 'react';
import { WppTypography } from '@wppopen/components-library-react';
import { SideModal } from 'components';
import styles from './Footer.module.scss';
import { Localization } from 'utils';

const { Main, MainText } = styles;

export const Footer = ({ localization }: any) => {
    const [isModalShown, setIsModalShown] = useState(false);

    const modalHandler = () => {
        setIsModalShown(true);
    };

    return (
        <div className={Main} id="footer">
            {Localization.US === localization && (
                <WppTypography
                    type="xs-body"
                    className={MainText}
                    onClick={modalHandler}
                    data-testid="PROJECTION.FOOTER.LICENSE.TEXT"
                >
                    Contains public sector information licensed under the Federal Open Data Policy
                </WppTypography>
            )}
            <SideModal
                isSidebarShown={isModalShown}
                title="Compliance"
                setIsSidebarShown={setIsModalShown}
                localization={localization}
            />
        </div>
    );
};
